/* eslint-disable camelcase */
module.exports = {
	methods: {
		deals() {
			const self = this;

			return {
				async list({ offset = 0, limit = self.limit, search = null, tags = null, order_by = 'date', status = null, flushCache = false, see_future = 0, start_time = null, end_time = null, show_coupons = 0, show_description = 0, show_tags = 0 }) {
					try {
						const headers = {
							Authorization: false,
						};

						if (flushCache) headers['Cache-Control'] = 'no-cache';

						const response = await self.$http.get(
							'deals', {
								params: {
									offset,
									limit,
									search,
									tags,
									order_by,
									status,
									see_future,
									start_time,
									end_time,
									show_coupons,
									show_description,
									show_tags,
								},
								headers,
							},
						);

						const deals = {
							total: response.data.deals.total,
							results: self.helpers().formatDeals(response.data.deals.results, true),
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async popular() {
					try {
						const response = await self.$http.get(
							'deals/recommended ', {
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.deals.total,
							results: self.helpers().formatDeals(response.data.deals.results),
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async get(id) {
					try {
						const response = await self.$http.get(
							`/admin/deals/${id}`, {
								params: {},
								headers: {
									Authorization: false,
								},
							},
						);

						const deal = self.helpers().formatDeals([response.data.deal]);

						return {
							ok: true,
							data: deal[0],
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async add(deal, mod = false) {
					try {
						self.loader = 'Añadiendo nuevo chollo';

						let url = 'deals';
						if (mod) {
							url = 'admin/deals';
						}

						const response = await self.$http.post(
							url, deal, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						if (mod) {
							return {
								ok: true,
								id: response.data.deal_id,
								error: null,
							};
						}
						return {
							ok: true,
							data: response.data.deal,
							error: null,
						};
					} catch (error) {
						self.resetStatus();

						return {
							ok: false,
							data: [],
						};
					}
				},
				async edit(dealId, params) {
					try {
						self.loader = `Editando chollo: #${dealId}`;

						const response = await self.$http.patch(
							`admin/deals/${dealId}`, params, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return { ok: true, id: response.data.deal_id };
					} catch (error) {
						self.resetStatus();
						return { ok: false, data: null };
					}
				},
				async like(dealId) {
					try {
						await self.$http.put(
							`deals/${dealId}/like`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async unlike(dealId) {
					try {
						await self.$http.delete(
							`deals/${dealId}/like`, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async report(dealId) {
					try {
						await self.$http.put(
							`deals/${dealId}/report`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async uploadImage(formData) {
					try {
						const response = await self.$http.post(
							'app/api/deal', formData, {
								headers: {
									Authorization: true,
									baseType: 'cdn',
								},
							},
						);

						self.resetStatus();

						return {
							ok: true,
							image_url: response.data.image_url,
						};
					} catch (error) {
						self.resetStatus();

						return {
							ok: false,
							image_url: null,
						};
					}
				},
			};
		},
	},
};
